import { Modal } from 'antd'
import Styles from '../css/vehicleModals.module.scss'
import  Cancel from "../../../../assets/cancel.svg";
import  Caution from "../../../../assets/cautionfailedicon.svg";

const VehicleLoanCancelledModal = (props:any) => {
    return ( 
        <div>
            <Modal title="Basic Modal" centered destroyOnClose={true} width={400} open={props.isModalOpen} onOk={props.handleOk} onCancel={props.handleCancel}>
                <div className={Styles.modalContentVerification}>
                   <div className={Styles.cancelDiv}><img onClick={props.handleCancel} src={Cancel} className={Styles.cancelIcon} alt="horse" /></div>
                   <div className={Styles.cautionDiv}><img onClick={props.handleCancel} src={Caution} className={Styles.cautionIcon} alt="horse" /></div>
                   <div style={{textAlign:'center'}} className={Styles.title}>Transaction cancelled</div>
                   <button onClick={props.goToHistory} className={Styles.btnOutline}>RETURN</button>
               </div>
            </Modal>   
        </div>
     );
}
 
export default VehicleLoanCancelledModal;